import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "grey" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tooltip_info = _resolveComponent("tooltip-info")!
  const _component_VJoyInput = _resolveComponent("VJoyInput")!
  const _component_VJoyFormError = _resolveComponent("VJoyFormError")!
  const _component_VJoyWrapper = _resolveComponent("VJoyWrapper")!
  const _component_brief_hub_step_layout = _resolveComponent("brief-hub-step-layout")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_brief_hub_step_layout, null, {
      right: _withCtx(() => [
        _createVNode(_component_tooltip_info, {
          icon: "megaphone",
          title: _ctx.$msg('customer.brief.form.tooltip.tip')
        }, {
          content: _withCtx(() => [
            _createElementVNode("p", {
              innerHTML: _ctx.$msg('customer.brief.form.freelancer.job-title.tooltip.content', _ctx.briefFreelancerProfile.selectedFamilyLabel)
            }, null, 8, _hoisted_1)
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$msg('customer.brief.form.freelancer.profile.job.title')), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_VJoyWrapper, {
          direction: "column",
          align: "stretch",
          "row-gap": "4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_VJoyInput, {
              id: "JobTitle",
              ref: "inputJobTitle",
              modelValue: _ctx.jobTitle,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.jobTitle) = $event)),
              autofocus: "",
              name: "job-title",
              type: "text",
              required: "",
              autocomplete: "off",
              placeholder: _ctx.placeholder,
              min: _ctx.minLength,
              max: _ctx.maxLength
            }, null, 8, ["modelValue", "placeholder", "min", "max"]),
            (_ctx.showJobTitleError)
              ? (_openBlock(), _createBlock(_component_VJoyFormError, {
                  key: 0,
                  "no-html-error-text": "This is an error"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _createTextVNode(_toDisplayString(_ctx.$msg('customer.brief.form.freelancer.profile.job.title.length.error')) + " ", 1),
                        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$msg('customer.brief.form.freelancer.profile.job.title.length.error.more')), 1)
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}